// // import { ChevronDown } from 'lucide-react'
// import React, { useEffect, useState } from 'react';
// import { FaEnvelope } from 'react-icons/fa';
// import { FiSearch } from 'react-icons/fi';
// import { useDispatch, useSelector } from 'react-redux';
// import { useLocation, useParams } from 'react-router-dom';
// import { status } from '../../_constants';
// import { correspondanceAction } from '../../_actions';
// import { config } from '../../config';
// import { useNavigate } from 'react-router-dom';
// import wordIcon from '../../../src/utils/images/wordIcon.png';
// import pdfIcon from '../../../src/utils/images/pdfIcon.svg';
// import mailIcon from '../../../src/utils/images/mailIcon.svg';
// import imgIcon from '../../../src/utils/images/imgIcon.svg';
// import excelIcon from '../../../src/utils/images/excel-Icon.png';
// import Sidebar from "../../component/Sidebar";
// import arrow from "../../utils/images/arrow.svg";
// import downloadicon from "../../utils/images/download_icon.svg";
// import emailicon from "../../utils/images/email_icon.svg";
// import printicon from "../../utils/images/priter_icon.svg";
// import copyIcon from "../../utils/images/copy_icon.svg";


// function ViewDocuments() {
//     const navigate = useNavigate();
//     const [isOpen, setIsOpen] = useState(false);
//     const { id } = useParams();
//     const dispatch = useDispatch();
//     const location = useLocation();
//     // const [correspondences, setCorrespondences] = useState(location.state?.data || []);
//     const [allCorrespondences, setAllCorrespondences] = useState([]);
//     const [filteredCorrespondences, setFilteredCorrespondences] = useState(location.state?.data || []);
//     const correspondanceData = useSelector((state) => state.correspondence);
//     const [search, setSearch] = useState('');
//     const [seletDocument, setSeletDocument] = useState(null)
//     const [activeDocument, setActiveDocument] = useState(null);

//     // useEffect(() => {
//     //     if (correspondanceData?.get_correspondence_status === status.SUCCESS) {
//     //         setCorrespondences(correspondanceData.get_correspondence_data);
//     //         setFilteredCorrespondences(correspondanceData.get_correspondence_data);
//     //     }
//     //     console.log(24, correspondanceData.get_correspondence_data);

//     // }, [correspondanceData]);
//     useEffect(() => {
//         if (correspondanceData?.get_correspondence_status === status.SUCCESS) {
//             const data = correspondanceData.get_correspondence_data || [];
//             setAllCorrespondences(data);
//             setFilteredCorrespondences(data);
//         }
//     }, [correspondanceData]);


//     useEffect(() => {
//         if (filteredCorrespondences.length === 0 && id) {
//             dispatch(correspondanceAction.getCorrespondance(id));
//         }
//     }, [dispatch, id, filteredCorrespondences.length])


//     useEffect(() => {
//         const filtered = allCorrespondences.filter((item) =>
//             item.name?.toLowerCase().includes(search.toLowerCase())
//         );
//         setFilteredCorrespondences(filtered);
//     }, [search, allCorrespondences]);


//     const handleDownload = () => {
//         if (!seletDocument) return;

//         const fileName = seletDocument.document.replace(/\\/g, '/').replace('uploads/', '');
//         const downloadUrl = `${config.localApiUrl}/downloads/${fileName}`;

//         const link = document.createElement('a');
//         link.href = downloadUrl;
//         link.setAttribute('download', fileName);
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//     };
//     const getFileIcon = (filename) => {
//         if (!filename) return <FaEnvelope className="text-gray-400" />;

//         const ext = filename.split('.').pop().toLowerCase();

//         if (['doc', 'docx'].includes(ext)) return <img src={wordIcon} className="icons" />;
//         if (['pdf'].includes(ext)) return <img src={pdfIcon} className="icons" />;
//         if (['xls', 'xlsx'].includes(ext)) return <img src={excelIcon} className='icons' />;
//         if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'].includes(ext)) return <img src={imgIcon} className="icons" />;

//         return <img src={mailIcon} className="icons" />;
//     };

//     const handlePrint = () => {
//         if (!seletDocument) return;
//         const fileUrl = `${config.localApiUrl}/${seletDocument.document.replace(/\\/g, '/')}`;
//         const isPdf = seletDocument.document.toLowerCase().endsWith('.pdf');
//         const previewUrl = isPdf
//             ? fileUrl
//             : `https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true`;
//         const printWindow = window.open(previewUrl, '_blank');
//         if (printWindow) {
//             printWindow.onload = () => {
//                 printWindow.print();
//             };
//         }
//     };

//     return (
//         <>
//             <div className='main-wrapper-dashboard'>
//                 <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />
//                 <div className='main-wrapper-document'>
//                     <div className="top-bar">
//                         <h3>Document Preview: Copy of Default Letter to Mr John Smith</h3>
//                         <div onClick={() => navigate(`/matter-details/${id}`)} className='close_icon' />
//                     </div>
//                     <div className="flex h-screen">
//                         <aside className="left-sidebars">
//                             <div className="search-bar">
//                                 <FiSearch className='search-icon' />
//                                 <input
//                                     type="text"
//                                     placeholder="Search correspondence..."
//                                     value={search}
//                                     onChange={(e) => setSearch(e.target.value)}
//                                     className="form-control"
//                                 />

//                             </div>
//                             <div className='overflow-y-auto scrollable-container max-h-96 scrollbar-thin scrollbar-thumb-cyan-700 scrollbar-track-gray-100'>
//                                 <ul>
//                                     {filteredCorrespondences.length > 0 ? (
//                                         filteredCorrespondences.map((item, index) => (
//                                             <li
//                                                 key={index}
//                                                 className={`flex items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer 
//                                                     ${activeDocument?.document === item.document ? 'active' : ''}`}
//                                                 onClick={() => {
//                                                     setSeletDocument(item);
//                                                     setActiveDocument(item);
//                                                 }}
//                                             >
//                                                 {getFileIcon(item.document)}
//                                                 <div>
//                                                     <p className={`font-medium ${activeDocument?.document === item.document ? 'text-blue-600' : ''}`}>
//                                                         {item.name}
//                                                     </p>
//                                                 </div>
//                                             </li>
//                                         ))
//                                     ) : (
//                                         <li className="text-gray-500 p-2">No documents found</li>
//                                     )}
//                                 </ul>
//                             </div>
//                             <div className='Copy-default'>
//                                 <div className='copy-icon'>
//                                     <img src={copyIcon} alt='' className='copy-icon' />
//                                     <p>Copy of Default Letter to Mr John Smith</p>
//                                 </div>
//                                 <div className='content'>
//                                     <p className='left'>
//                                         Last Modified by:
//                                     </p>
//                                     <p className='right'>
//                                         Mr John Smith
//                                     </p>
//                                 </div >
//                                 <div className='content'>
//                                     <p className='left'>
//                                         Date Created:
//                                     </p>
//                                     <p className='right'>
//                                         7 Nov 2025
//                                     </p>
//                                 </div >
//                                 <div className='content'>
//                                     <p className='left'>
//                                         File Type:
//                                     </p>
//                                     <p className='right'>
//                                         Docx
//                                     </p>
//                                 </div >
//                             </div>

//                         </aside>
//                         <main className="right-sidebar">
//                             {/* Toolbar */}
//                             <div className="top-button">
//                                 <button className="">
//                                     <img src={wordIcon} alt='' className='word-icon' />
//                                     Edit in Word
//                                     <img src={arrow} alt='' className='arrow-icon' />
//                                 </button>
//                                 <button className="">
//                                     <img src={emailicon} alt='' className='email-icon' />
//                                     Email
//                                     <img src={arrow} alt='' className='arrow-icon' />
//                                 </button>
//                                 <button onClick={handleDownload}>
//                                     <img src={downloadicon} alt='' className='download-icon' />
//                                     Download
//                                     <img src={arrow} alt='' className='arrow-icon' />
//                                 </button>

//                                 <button onClick={handlePrint}>
//                                     <img src={printicon} alt='' className='print-icon' />
//                                     Print
//                                 </button>
//                             </div>

//                             {/* Document Preview */}
//                             {/* <div className="document-preview m-4">
//                                 {seletDocument ? (
//                                     (() => {
//                                         const fileUrl = `${config.localApiUrl}/${seletDocument.document.replace(/\\/g, '/')}`;
//                                         const isPdf = seletDocument.document.toLowerCase().endsWith('.pdf');
//                                         const previewUrl = isPdf
//                                             ? fileUrl
//                                             : `https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true`;

//                                         return (
//                                             <iframe
//                                                 src={previewUrl}
//                                                 title={seletDocument.name}
//                                                 width="80%"
//                                                 height="550px"
//                                                 className="border rounded"
//                                             />
//                                         );
//                                     })()
//                                 ) : (
//                                     <p className="text-gray-500">Select a document to preview</p>
//                                 )}
//                             </div> */}

//                             <div className="document-preview m-4">
//                                 {seletDocument ? (
//                                     (() => {
//                                         const fileUrl = `${config.localApiUrl}/${seletDocument.document.replace(/\\/g, '/')}`;
//                                         const fileName = seletDocument.document.toLowerCase();

//                                         if (fileName.endsWith('.pdf')) {
//                                             return (
//                                                 <iframe
//                                                     src={fileUrl}
//                                                     title={seletDocument.name}
//                                                     width="80%"
//                                                     height="550px"
//                                                     className="border rounded"
//                                                 />
//                                             );
//                                         } else if (
//                                             fileName.endsWith('.jpg') ||
//                                             fileName.endsWith('.jpeg') ||
//                                             fileName.endsWith('.png') ||
//                                             fileName.endsWith('.gif') ||
//                                             fileName.endsWith('.bmp') ||
//                                             fileName.endsWith('.svg')
//                                         ) {
//                                             return (
//                                                 <img
//                                                     src={fileUrl}
//                                                     alt={seletDocument.name}
//                                                     className="max-w-full max-h-[550px] border rounded"
//                                                 />
//                                             );
//                                         } else {
//                                             // fallback to Google Viewer for other doc types
//                                             const gviewUrl = `https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true`;
//                                             return (
//                                                 <iframe
//                                                     src={gviewUrl}
//                                                     title={seletDocument.name}
//                                                     width="80%"
//                                                     height="550px"
//                                                     className="border rounded"
//                                                 />
//                                             );
//                                         }
//                                     })()
//                                 ) : (
//                                     <p className="text-gray-500">Select a document to preview</p>
//                                 )}
//                             </div>


//                         </main>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// }

// export default ViewDocuments



import React, { useEffect, useState } from 'react';
import { FaEnvelope } from 'react-icons/fa';
import { FiSearch } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { status } from '../../_constants';
import { correspondanceAction } from '../../_actions';
import { config } from '../../config';
import wordIcon from '../../../src/utils/images/wordIcon.png';
import pdfIcon from '../../../src/utils/images/pdfIcon.svg';
import mailIcon from '../../../src/utils/images/mailIcon.svg';
import imgIcon from '../../../src/utils/images/imgIcon.svg';
import excelIcon from '../../../src/utils/images/excel-Icon.png';
import Sidebar from "../../component/Sidebar";
import arrow from "../../utils/images/arrow.svg";
import downloadicon from "../../utils/images/download_icon.svg";
import emailicon from "../../utils/images/email_icon.svg";
import printicon from "../../utils/images/priter_icon.svg";
import copyIcon from "../../utils/images/copy_icon.svg";
import * as XLSX from 'xlsx';

function ViewDocuments() {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const { id } = useParams();
    const dispatch = useDispatch();
    const location = useLocation();
    const [allCorrespondences, setAllCorrespondences] = useState([]);
    const [filteredCorrespondences, setFilteredCorrespondences] = useState(location.state?.data || []);
    const correspondanceData = useSelector((state) => state.correspondence);
    const [search, setSearch] = useState('');
    const [seletDocument, setSeletDocument] = useState(null);
    const [activeDocument, setActiveDocument] = useState(null);
    const [excelData, setExcelData] = useState(null);
    const [excelHeaders, setExcelHeaders] = useState([]);
    const [fileReady, setFileReady] = useState(false);

    useEffect(() => {
        if (seletDocument) {
            setFileReady(false);
            const timer = setTimeout(() => {
                setFileReady(true);
            }, 100);
            return () => clearTimeout(timer);
        }
    }, [seletDocument]);

    useEffect(() => {
        if (seletDocument && fileReady && (seletDocument.name.endsWith(".xls") || seletDocument.name.endsWith(".xlsx"))) {
            fetchExcelData();
        } else {
            setExcelData(null);
            setExcelHeaders([]);
        }
    }, [seletDocument, fileReady]);

    useEffect(() => {
        if (correspondanceData?.get_correspondence_status === status.SUCCESS) {
            const data = correspondanceData.get_correspondence_data || [];
            setAllCorrespondences(data);
            setFilteredCorrespondences(data);
        }
    }, [correspondanceData]);

    useEffect(() => {
        if (filteredCorrespondences.length === 0 && id) {
            dispatch(correspondanceAction.getCorrespondance(id));
        }
    }, [dispatch, id, filteredCorrespondences.length]);

    useEffect(() => {
        const filtered = allCorrespondences.filter((item) =>
            item.name?.toLowerCase().includes(search.toLowerCase())
        );
        setFilteredCorrespondences(filtered);
    }, [search, allCorrespondences]);

    const handleDownload = () => {
        if (!seletDocument) return;

        const fileName = seletDocument.document.replace(/\\/g, '/').replace('uploads/', '');
        const downloadUrl = `${config.localApiUrl}/downloads/${fileName}`;

        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const getFileIcon = (filename) => {
        if (!filename) return <FaEnvelope className="text-gray-400" />;

        const ext = filename.split('.').pop().toLowerCase();

        if (["doc", "docx"].includes(ext)) return <img src={wordIcon} className="icons" alt="Word icon" />;
        if (["pdf"].includes(ext)) return <img src={pdfIcon} className="icons" alt="PDF icon" />;
        if (["xls", "xlsx"].includes(ext)) return <img src={excelIcon} className='icons' alt="Excel icon" />;
        if (["jpg", "jpeg", "png", "gif", "bmp", "svg"].includes(ext)) return <img src={imgIcon} className="icons" alt="Image icon" />;

        return <img src={mailIcon} className="icons" alt="Mail icon" />;
    };

    const handlePrint = () => {
        if (!seletDocument) return;
        const fileUrl = `${config.localApiUrl}/${seletDocument.document.replace(/\\/g, '/')}`;
        const isPdf = seletDocument.document.toLowerCase().endsWith('.pdf');
        const previewUrl = isPdf
            ? fileUrl
            : `https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true`;
        const printWindow = window.open(previewUrl, '_blank');
        if (printWindow) {
            printWindow.onload = () => {
                printWindow.print();
            };
        }
    };

    const fetchExcelData = async () => {
        try {
            const fileUrl = `${config.localApiUrl}/${seletDocument.document.replace(/\\/g, "/")}`;
            const response = await fetch(fileUrl);
            const arrayBuffer = await response.arrayBuffer();
            const workbook = XLSX.read(arrayBuffer, { type: "array" });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            if (jsonData.length > 0) {
                setExcelHeaders(jsonData[0]);
                setExcelData(jsonData.slice(1));
            }
        } catch (error) {
            console.error("Failed to load Excel file", error);
        }
    };

    const renderExcelPreview = () => {
        if (!excelData || excelData.length === 0) return <p>No data available in the Excel file</p>;

        return (
            <div className="excel-preview-container">
                <table className="excel-table">
                    <thead>
                        <tr>
                            {excelHeaders.map((header, index) => (
                                <th key={index}>{header}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {excelData.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {excelHeaders.map((header, colIndex) => (
                                    <td key={colIndex}>{row[colIndex]}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    };

    const renderDocumentPreview = () => {
        if (!seletDocument || !fileReady) {
            return <p className="text-gray-500">Select a document to preview</p>;
        }

        const fileUrl = `${config.localApiUrl}/${seletDocument.document.replace(/\\/g, '/')}`;
        const fileName = seletDocument.document.toLowerCase();

        if ((fileName.endsWith('.xls') || fileName.endsWith('.xlsx')) && excelData) {
            return renderExcelPreview();
        }

        if (fileName.endsWith('.pdf')) {
            return (
                <iframe
                    src={fileUrl}
                    title={seletDocument.name}
                    width="100%"
                    height="550px"
                    className="border rounded"
                />
            );
        }

        if ([".jpg", ".jpeg", ".png", ".gif", ".bmp", ".svg"].some(ext => fileName.endsWith(ext))) {
            return (
                <div className="image-preview-container">
                    <img
                        src={fileUrl}
                        alt={seletDocument.name}
                    />
                </div>
            );
        }

        const gviewUrl = `https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true`;
        return (
            <iframe
                src={gviewUrl}
                title={seletDocument.name}
                width="100%"
                height="550px"
                className="border rounded"
            />
        );
    };

    return (
        <>
            <div className='main-wrapper-dashboard'>
                <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />
                <div className='main-wrapper-document'>
                    <div className="top-bar">
                        <h3>Document Preview: Copy of Default Letter to Mr John Smith</h3>
                        <div onClick={() => navigate(`/matter-details/${id}`)} className='close_icon' />
                    </div>
                    <div className="flex h-screen">
                        <aside className="left-sidebars">
                            <div className="search-bar">
                                <FiSearch className='search-icon' />
                                <input
                                    type="text"
                                    placeholder="Search correspondence..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    className="form-control"
                                />
                            </div>
                            <div className='overflow-y-auto scrollable-container max-h-96 scrollbar-thin scrollbar-thumb-cyan-700 scrollbar-track-gray-100'>
                                <ul>
                                    {filteredCorrespondences.length > 0 ? (
                                        filteredCorrespondences.map((item, index) => (
                                            <li
                                                key={index}
                                                className={`flex items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer ${activeDocument?.document === item.document ? 'active' : ''}`}
                                                onClick={() => {
                                                    setSeletDocument(item);
                                                    setActiveDocument(item);
                                                }}
                                            >
                                                {getFileIcon(item.document)}
                                                <div>
                                                    <p className={`font-medium ${activeDocument?.document === item.document ? 'text-blue-600' : ''}`}>
                                                        {item.name}
                                                    </p>
                                                </div>
                                            </li>
                                        ))
                                    ) : (
                                        <li className="text-gray-500 p-2">No documents found</li>
                                    )}
                                </ul>
                            </div>
                            <div className='Copy-default'>
                                <div className='copy-icon'>
                                    <img src={copyIcon} alt='' className='copy-icon' />
                                    <p>Copy of Default Letter to Mr John Smith</p>
                                </div>
                                <div className='content'>
                                    <p className='left'>Last Modified by:</p>
                                    <p className='right'>Mr John Smith</p>
                                </div>
                                <div className='content'>
                                    <p className='left'>Date Created:</p>
                                    <p className='right'>7 Nov 2025</p>
                                </div>
                                <div className='content'>
                                    <p className='left'>File Type:</p>
                                    <p className='right'>Docx</p>
                                </div>
                            </div>
                        </aside>
                        <main className="right-sidebar">
                            <div className="top-button">
                                <button className="">
                                    <img src={wordIcon} alt='Word icon' className='word-icon' />
                                    Edit in Word
                                    <img src={arrow} alt='Arrow icon' className='arrow-icon' />
                                </button>
                                <button className="">
                                    <img src={emailicon} alt='Email icon' className='email-icon' />
                                    Email
                                    <img src={arrow} alt='Arrow icon' className='arrow-icon' />
                                </button>
                                <button onClick={handleDownload}>
                                    <img src={downloadicon} alt='Download icon' className='download-icon' />
                                    Download
                                    <img src={arrow} alt='Arrow icon' className='arrow-icon' />
                                </button>
                                <button onClick={handlePrint}>
                                    <img src={printicon} alt='Print icon' className='print-icon' />
                                    Print
                                </button>
                            </div>
                            <div className="document-preview m-4">
                                {renderDocumentPreview()}
                            </div>
                        </main>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ViewDocuments;